import { call, put } from "redux-saga/effects";
import {
  getContactMethods,
  addContactMethods,
  updateContactMethods,
  deleteContactMethods,
} from "@Api/contactMethodsApi";
import actions from "@Src/redux/rootActions";

const {
  fetchContactMethodsSuccess,
  fetchContactMethodsFailure,
  createContactMethodsSuccess,
  createContactMethodsFailure,
  updateContactMethodsSuccess,
  updateContactMethodsFailure,
  deleteContactMethodsSuccess,
  deleteContactMethodsFailure,
} = actions.contactMethods;

export function* doGetContactMethods() {
  try {
    const response = yield call(getContactMethods);

    yield put(fetchContactMethodsSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(fetchContactMethodsFailure(error));
  }
}

export function* doAddContactMethods(action) {
  try {
    const response = yield call(addContactMethods, action.payload);

    yield put(createContactMethodsSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(createContactMethodsFailure(error));
  }
}

export function* doUpdateContactMethods(action) {
  try {
    const response = yield call(updateContactMethods, action.payload);

    yield put(updateContactMethodsSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(updateContactMethodsFailure(error));
  }
}

export function* doDeleteContactMethods(action) {
  try {
    const response = yield call(deleteContactMethods, action.payload);

    yield put(deleteContactMethodsSuccess(response));
  } catch (error) {
    console.error(error);

    yield put(deleteContactMethodsFailure(error));
  }
}
